import React from 'react';
import styled from 'styled-components';
import { ScaleLoader } from 'react-spinners';
import Portal from './Portal';

const Overlay = styled.div`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #000;
    opacity: 0.7;
`;

const Center = styled.div`
    position: fixed;

    height: 30px;
    width: 60px;
    overflow: show;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;

    color: red;
    font-size: 30px;
`;

class BusyOverlay extends React.Component {
    render() {
        return (
            <Portal>
                <Overlay>
                    <Center>
                        <ScaleLoader color="#fff" loading={true} />
                    </Center>
                </Overlay>
            </Portal>
        );
    }
}

export default BusyOverlay;



// WEBPACK FOOTER //
// ./src/uic/BusyOverlay.js